import React from 'react'

function NotFoundPage() {
  return (
    <div>
        <img style={{height: "100%"}} src="/images/404.jpg" alt="Not found" />
    </div>
  )
}

export default NotFoundPage